import { mockData } from "./Mock";
import {OrderStatus } from "../../models/Order";

// 订单列表mock数据
mockData.set("getOrders", [
    {
        orderId: "ORD202403010001",
        productId: "PRD001",
        productName: "测试商品1",
        productVersion: 1,
        sellerNickname: "卖家1",
        sellerId: "S001",
        buyerId: "B001",
        buyerNickname: "买家1",
        orderAmount: 199.99,
        status: OrderStatus.PENDING_PAYMENT,
        orderTime: "2024-03-01T10:00:00Z",
        feeRate: 15,
        selfOperated: false,
        commissionAllocation: {
            items: [
                {
                    sellerId: "S001",
                    sellerPhone: "13800138001",
                    sellerNickname: "分销商1",
                    commissionAmount: 59.99,
                    responsibility: "推广"
                }
            ]
        }
    },
    {
        orderId: "ORD202403010002",
        productId: "PRD002",
        productName: "测试商品2",
        productVersion: 0,
        sellerNickname: "卖家2",
        sellerId: "S002",
        buyerId: "B002",
        buyerNickname: "买家2",
        orderAmount: 299.99,
        status: OrderStatus.SERVICE_IN_PROGRESS,
        orderTime: "2024-03-01T11:00:00Z",
        paymentTime: "2024-03-01T11:05:00Z",
        serviceStartTime: "2024-03-01T11:10:00Z",
        feeRate: 15,
        selfOperated: false,
        commissionAllocation: {
            items: [
                {
                    sellerId: "S002",
                    sellerPhone: "13800138002",
                    sellerNickname: "分销商2",
                    commissionAmount: 89.99,
                    responsibility: "推广"
                },
                {
                    sellerId: "S003",
                    sellerPhone: "13800138003",
                    sellerNickname: "客服1",
                    commissionAmount: 59.99,
                    responsibility: "售后服务"
                }
            ]
        }
    },
    {
        orderId: "ORD202403010003",
        productId: "PRD003",
        productName: "测试商品3",
        productVersion: 1,
        sellerNickname: "卖家3",
        sellerId: "S003",
        buyerId: "B003",
        buyerNickname: "买家3",
        orderAmount: 399.99,
        status: OrderStatus.COMPLETED,
        orderTime: "2024-03-01T09:00:00Z",
        paymentTime: "2024-03-01T09:05:00Z",
        serviceStartTime: "2024-03-01T09:10:00Z",
        completionTime: "2024-03-01T15:00:00Z",
        feeRate: 15,
        selfOperated: true,
        commissionAllocation: {
            items: [
                {
                    sellerId: "S004",
                    sellerPhone: "13800138004",
                    sellerNickname: "分销商4",
                    commissionAmount: 119.99,
                    responsibility: "推广"
                }
            ]
        }
    }
]); 